import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { createOnboardingHandlers } from './handlers';
import { OnboardingStore } from './types';
import { ZustandStores } from '../utils';

const initialState = {
  isOnboardingComplete: false,
  currentStep: 0,
  isLoading: false,
};

export const useOnboardingStore = create<OnboardingStore>()(
  persist(
    (set) => ({
      ...initialState,
      ...createOnboardingHandlers(set),
    }),
    {
      name: ZustandStores.ONBOARDING_STORE,
    },
  ),
);
